import React from 'react';
import { useLocationsData } from '../hooks/useLocationsData';
import FilterItemList from '../components/FilterItemList';
import FilterModal from '../components/FilterModal';

const Widget = () => {
	const { isReady, error } = useLocationsData();
	if (error) {
		return null;
	}

	return (
		<React.Fragment>
			<div className="d-none d-md-flex">
				<FilterItemList />
			</div>
			<FilterModal isReady={isReady} />
		</React.Fragment>
	);
};

export default Widget;
